import React from 'react';
import { Modal, Button } from 'semantic-ui-react';
import classNames from 'classnames';
import './ModalGeneric.scss';

export default function ModalGeneric(props) {
  const {
    className,
    actions,
    title,
    children,
    open,
    onModalClose,
    showCloseButton,
    scrollingContent = false,
    ...rest
  } = props;

  return (
    <Modal
      open={open}
      onClose={onModalClose}
      className={classNames(className, 'generic-modal')}
      {...rest}
    >
      {showCloseButton || title ? (
        <Modal.Header>
          {showCloseButton ? (
            <Button
              className="close-icon borderless"
              basic
              icon='close'
              floated="right"
              onClick={onModalClose}
            >

            </Button>
          ) : null}
          {title}
        </Modal.Header>
      ) : null}

      {children ? (
        <Modal.Content scrolling={scrollingContent}>{children}</Modal.Content>
      ) : null}
      {actions ? <Modal.Actions>{actions}</Modal.Actions> : null}
    </Modal>
  );
}
